import { defineMessages } from 'react-intl';

export default defineMessages({
  CLOSE_DRAWER: {
    defaultMessage: 'Fermer le plein écran',
  },
} as const);
